var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "tag": "div"
    },
    on: {
      "enter": _vm.enterSearch,
      "leave": _vm.leaveSearch
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchOn),
      expression: "searchOn"
    }],
    attrs: {
      "id": "search-overlay"
    }
  }, [_c('div', {
    staticClass: "search-overlay-header"
  }, [_c('div', {
    staticClass: "inner container"
  }, [_c('div', {
    staticClass: "site-logo"
  }, [_c('a', {
    staticClass: "home-link",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "BAHR"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "close-search",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "square"
    }
  }, [_c('g', {
    attrs: {
      "id": "Mobil-search",
      "transform": "translate(-334.000000, -19.000000)",
      "stroke": "#FFFFFF",
      "stroke-width": "2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Close",
      "transform": "translate(266.000000, 15.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-2",
      "transform": "translate(69.000000, 5.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.714285714,0.714285714 L19.2857143,19.2857143",
      "id": "Line"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.714285714,0.714285714 L19.2857143,19.2857143",
      "id": "Line",
      "transform": "translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
    }
  })])])])])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.strings.close))])]), _vm._v(" "), _c('div', {
    staticClass: "global-search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInputValue),
      expression: "searchInputValue"
    }],
    ref: "search",
    attrs: {
      "id": "gsi",
      "type": "text",
      "placeholder": _vm.searchInputPlaceholder
    },
    domProps: {
      "value": (_vm.searchInputValue)
    },
    on: {
      "keyup": function($event) {
        _vm.search()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Søk",
      "transform": "translate(-99.000000, -202.000000)",
      "stroke-width": "2",
      "stroke": "#FFFFFF"
    }
  }, [_c('g', {
    attrs: {
      "id": "Search",
      "transform": "translate(100.000000, 198.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icon:-Search"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000, 5.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.5,13.5 L19.5,19.5",
      "id": "Line",
      "fill": "#343638",
      "stroke-linecap": "square"
    }
  }), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "7.5",
      "cy": "7.5",
      "r": "7.5"
    }
  })])])])])])]), _vm._v(" "), (_vm.loading) ? _c('barPreloader') : _vm._e()], 1)])]), _vm._v(" "), (_vm.results) ? _c('transition-group', {
    staticClass: "container global-search-results",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnterAnimation,
      "enter": _vm.enterAnimation,
      "leave": _vm.leaveAnimation
    }
  }, _vm._l((_vm.results), function(resArr, postType) {
    return (_vm.results[postType] && _vm.results[postType][0]) ? _c('div', {
      key: postType,
      staticClass: "search-resoultat-roup",
      staticStyle: {
        "margin-bottom": "40px"
      }
    }, [_c('h4', {
      staticClass: "search-post-type-name"
    }, [_vm._v(_vm._s(_vm.results[postType][0].post_type))]), _vm._v(" "), _vm._l((_vm.results[postType]), function(res, ind) {
      return (_vm.results[postType]) ? _c('a', {
        key: ind,
        staticClass: "search-result",
        attrs: {
          "href": res.slug
        }
      }, [_c('span', {
        staticClass: "title",
        domProps: {
          "innerHTML": _vm._s(res.title)
        }
      }), _vm._v(" "), _c('svg', {
        attrs: {
          "width": "20",
          "height": "10",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M19.77 4.29L15.688.227a.781.781 0 00-1.102 1.108l2.74 2.728H.781a.781.781 0 100 1.562h16.545l-2.74 2.727a.781.781 0 101.102 1.108l4.082-4.063a.782.782 0 000-1.106z",
          "fill": "#000",
          "fill-rule": "nonzero"
        }
      })])]) : _vm._e()
    })], 2) : _vm._e()
  })) : _vm._e(), _vm._v(" "), ((!_vm.loading && !_vm.results)) ? _c('div', {
    staticClass: "global-search-no-results"
  }, [_vm._v(_vm._s(_vm.startSearch))]) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b1a7314","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/Search.vue
// module id = 285
// module chunks = 0